import "../assets/Popup.css";
import { defineComponent as K, ref as x, useTemplateRef as A, computed as u, onUpdated as M, onMounted as T, openBlock as f, createElementBlock as I, unref as B, createBlock as F, resolveDynamicComponent as N, mergeProps as P } from "vue";
import { o as R } from "./index.72N0HVaZ.js";
import { a as e, b as y, A as q } from "./maps.ChaVcqWI.js";
import { u as D, h as H } from "./Text.vue_vue_type_style_index_0_lang.BEQZVGlu.js";
import { n as V, u as G } from "./useStore.DvPy8fc7.js";
import { r as O } from "./useModal.CgbJKM9V.js";
import { _ as U, C as W, a as j, b as z, c as J, N as Q, d as X, e as Y, f as Z, g as tt, h as et, i as ot } from "./StickyImage.vue_vue_type_style_index_0_lang.B1aOxgwU.js";
import { p as _ } from "./parseToolData.o66wWUUl.js";
import { f as at, t as nt } from "./focus.YB4BM1B3.js";
const st = ["data-builder-mode", "data-device", "data-content-alignment", "data-layout-kind", "data-text-direction", "aria-label"], _t = /* @__PURE__ */ K({
  __name: "Popup",
  props: {
    tool: {},
    context: {}
  },
  emits: [
    "hidden"
  ],
  setup(v, { expose: g, emit: h }) {
    const S = {
      [e.Circular]: U,
      [e.CustomImage]: W,
      [e.Fullscreen]: j,
      [e.FullscreenMini]: z,
      [e.LowerNotification]: J,
      [e.NotificationTab]: Q,
      [e.Sidebar]: X,
      [e.SideGradient]: Y,
      [e.Square]: Z,
      [e.SquareImage]: tt,
      [e.Sticky]: et,
      [e.StickyImage]: ot
    }, o = v, d = h, r = V(_({
      ...o,
      toolKind: y.Layer
    })), l = x(), a = A("rootEl");
    let m;
    const c = u(() => {
      const {
        language: t,
        deviceViewport: n
      } = o.context, {
        content: {
          modules: s
        },
        settings: {
          layout: i
        }
      } = o.tool, L = D(s), w = H(s);
      return {
        language: t,
        device: n,
        steps: L,
        hasSteps: w,
        layout: i
      };
    }), k = u(() => c.value.layout.type !== e.Sticky && c.value.layout.type !== e.StickyImage), b = u(() => {
      var n;
      if (!o.tool.settings.layout)
        return null;
      const t = (n = o.tool.settings.layout) == null ? void 0 : n.type;
      return S[t];
    });
    function E() {
      var t;
      (t = l.value) == null || t.show();
    }
    function p() {
      var t;
      (t = l.value) == null || t.hide();
    }
    M(() => {
      G(_({
        ...o,
        toolKind: y.Layer
      }));
    }), T(() => {
      r.handlers.callHandler(q.Show);
    });
    function $() {
      r.handlers.reset(), O(), d("hidden"), a.value && a.value.removeEventListener("keydown", m);
    }
    function C() {
      !o.context.builderMode && a.value && (at(a.value), k.value && (m = nt(a.value)));
    }
    return R("Escape", () => {
      d("hidden"), p();
    }, { target: a }), g({
      show: E,
      hide: p
    }), (t, n) => {
      var s, i;
      return f(), I("div", {
        ref_key: "rootEl",
        ref: a,
        class: "thn--tool thn--tool-popup",
        role: "dialog",
        "data-builder-mode": t.context.builderMode,
        "data-device": t.context.deviceViewport,
        "data-content-alignment": (s = t.tool.settings.layout) == null ? void 0 : s.contentAlignment,
        "data-layout-kind": (i = t.tool.settings.layout) == null ? void 0 : i.type,
        "data-text-direction": B(r).rtl ? "rtl" : "ltr",
        "aria-modal": "true",
        "aria-label": o.tool.name
      }, [
        (f(), F(N(b.value), P({
          ref_key: "componentRef",
          ref: l
        }, c.value, {
          onAfterLeave: $,
          onAfterEnter: C
        }), null, 16))
      ], 8, st);
    };
  }
});
export {
  _t as _
};
//# sourceMappingURL=Popup.vue_vue_type_style_index_0_lang.CakD9k9r.js.map
